import React from 'react';
import { Link } from 'react-router-dom';
import { FaUserAstronaut, FaBriefcaseMedical } from 'react-icons/fa';
import './QuizChoice.css';

const QuizChoice = () => {
  return (
    <section className="quiz-choice-root">
      <div className="quiz-choice-inner">
        <header className="quiz-choice-header">
          <h1 className="qc-title">
            Choose Your <span className="qc-gradient-text">Path</span>
          </h1>
          <p className="qc-subtitle">
            Two evidence‑informed tools to explore your fit across medical specialties.
          </p>
          <div className="qc-cta-cluster">
            <Link to="/" className="qc-cta-secondary">Back to Home</Link>
          </div>
        </header>

        <div className="qc-card-grid">
          <Link to="/quiz" className="qc-card" aria-label="MBTI Quiz – discover personality type and matching specialties">
            <div className="qc-card-icon">
              <FaUserAstronaut />
            </div>
            <h2 className="qc-card-title">MBTI Personality Quiz</h2>
            <p className="qc-card-text">
              Uncover your cognitive preference profile and see which specialties align with your interpersonal & decision styles.
            </p>
            <div className="qc-card-footer">
              <span className="qc-card-action">Start MBTI Quiz</span>
              <span className="qc-card-arrow" aria-hidden="true">→</span>
            </div>
          </Link>

            <Link to="/medmatch" className="qc-card" aria-label="Workstyle Quiz – match specialties by work preferences">
            <div className="qc-card-icon variant-alt">
              <FaBriefcaseMedical />
            </div>
            <h2 className="qc-card-title">Workstyle Alignment Quiz</h2>
            <p className="qc-card-text">
              Rank specialties using lifestyle, procedural intensity, acuity mix, teamwork dynamics, and training pathway factors.
            </p>
            <div className="qc-card-footer">
              <span className="qc-card-action">Start Workstyle Quiz</span>
              <span className="qc-card-arrow" aria-hidden="true">→</span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default QuizChoice;
